import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import DataForm from './DataForm';
import ListCollectionFunction from './ListCollectionFunction';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import DocsLink from '../../../../common/custom/DocsLink';
import ParentDocCard from '../../../common/ParentDocCard';
import VideoBox from '../../../../common/custom/VideoBox';

export default class DerivedFieldsBuilder extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    utilities: PropTypes.array.isRequired,
    collection: PropTypes.object.isRequired,
    collections: PropTypes.array.isRequired,
    common: PropTypes.array.isRequired,
  };

  showPublishedMessage = () => {
    const { updatedCollections, collection } = this.props;
    const { uuid } = collection;
    if (updatedCollections && updatedCollections.includes(uuid)) {
      return <span className="fw-lighter unpublished-tag text-warning">(Not Published)</span>;
    }
    return '';
  };

  render() {
    const {
      utilities,
      actions,
      commonActions,
      projectId,
      version,
      collection,
      showDerivedFieldCreateLoader,
      showUtilityDeleteLoader,
      collections,
      projectDetail,
      refCollectionItems,
      deleteFlag,
      plugins,
    } = this.props;
    return (
      <div className="row mx-auto">
        {/* TODO: Parent Card Changes */}
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('form')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title mb-0 pb-0">
                    Add Derived Field{' '}
                    {typeof collection !== 'undefined' && collection
                      ? ' To ' + collection.collectionTitle
                      : ''}
                    {this.showPublishedMessage()}
                  </h5>
                  <p className="mx-4 px-5">
                    Adds a field that shows the result of computations performed on the selected
                    fields.
                  </p>
                  <DataForm
                    actions={actions}
                    commonActions={commonActions}
                    version={version}
                    projectId={projectId}
                    collection={collection}
                    showDerivedFieldCreateLoader={showDerivedFieldCreateLoader}
                    collections={collections}
                    projectDetail={projectDetail}
                    refCollectionItems={refCollectionItems}
                    plugins={plugins}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
              <div className="card">
                <div
                  className="card-header card-header-icon"
                  data-background-color="drapcode-dark-blue"
                >
                  <i className={`wb ${drapcodeIcon('list')}`}></i>
                </div>
                <div className="card-content">
                  <h5 className="card-title">Derived Fields</h5>
                  <ListCollectionFunction
                    utilities={utilities}
                    actions={actions}
                    commonActions={commonActions}
                    projectId={projectId}
                    version={version}
                    collection={collection}
                    showUtilityDeleteLoader={showUtilityDeleteLoader}
                    deleteFlag={deleteFlag}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ParentDocCard>
          <h5>
            <b>About Derived Fields</b>
          </h5>
          <p>
            After adding fields in your collection, add derived fields, if you want. A derived field
            is a field that does computations on existing fields to generate derived values.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-derived-fields/derived-fields-in-collection" />
          <h5 className="mt-4">
            <b>About Custom Calculations </b>
          </h5>
          <p>
            You can run complex logic and calculations on your web app by creating by using custom
            calculations under derived fields. This feature helps you run complex computations on
            your data.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-derived-fields/custom-calculations/" />
          <h5 className="mt-4">
            <b>Custom Javascript Logic </b>
          </h5>
          <p>
            Custom JavaScript Logic allows you to create a derived field with a custom JavaScript
            logic or formula. To use this feature, you must have some knowledge of JavaScript.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-derived-fields/custom-javascript-logic" />
          <h5 className="mt-4">
            <b>Custom Sentence</b>
          </h5>
          <p>
            Custom sentence is a type of a derived field that allows you to configure content that
            changes dynamically according to the data.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-derived-fields/custom-sentence" />
          <h5 className="mt-4">
            <b>Save Derived Field</b>
          </h5>
          <p>Allows you to update the data of any derived field via a workflow event.</p>
          <DocsLink link="https://academy.drapcode.com/docs/app-derived-fields/save-derived-field" />
          <h5 className="mt-4">
            <b>Unix Timestamp</b>
          </h5>
          <p>
            Unix timestamp is a method to convert dates into seconds, milliseconds, microseconds and
            nanoseconds. For eg., 11-11-2022 is 1668160800000 (in milliseconds).
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-derived-fields/unix-timestamp" />
          <h5 className="mt-4">
            <b>Currency Format</b>
          </h5>
          <p>
            When you display numbers in currency format it adds a currency sign in front (or back)
            of them. In addition, you can specify the decimal places and comma or decimal separator
            as you wish to display the number in currency format.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-derived-fields/display-numbers-in-currency-format" />
          <h5 className="mt-4">
            <b>Date & Time Difference</b>
          </h5>
          <p>
            As the name suggests, Time Difference is a feature to get the difference between two
            date fields or current date, in derived fields. The difference can be obtained in years,
            months, weeks, days, hours and so on.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-derived-fields/date-time-difference" />
          <br />
          <h4>
            <b>Videos</b>
          </h4>

          <VideoBox
            videoLink="https://www.youtube.com/watch?v=59fVv6i-GgE&ab_channel=DrapCode"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/derivedField.jpg"
            heading="Derived Field View Video"
          />
          <br />
          <br />
          <VideoBox
            videoLink="https://www.youtube.com/watch?v=59fVv6i-GgE"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/customCalculationDerivedField.jpg"
            heading="Custom Calculations View Video"
          />
          <br />
          <br />
          <VideoBox
            videoLink="https://www.youtube.com/watch?v=-72-HUZlDL8"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Custom+Javascript+Example.jpg"
            heading="Custom Javascript Example View Video"
          />
          <br />
          <br />
          <VideoBox
            videoLink="https://www.youtube.com/watch?v=6suzZEhahjM"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Custom+Sentence+Derived+Fields.jpg"
            heading="Custom Sentence Derived Fields View Video"
          />
          <br />
          <br />
          <VideoBox
            videoLink="https://www.youtube.com/watch?v=K-3L-jzFAb0"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Save+Derived+Field+Values.jpg"
            heading="Save Derived Field Values View Video"
          />
          <br />
          <br />
          <VideoBox
            videoLink="https://www.youtube.com/watch?v=K-3L-jzFAb0"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Unix+Time+to+Human+Readable+Date+Format.jpg"
            heading="Unix Time to Human Readable Date Format View Video"
          />
          <br />
          <br />
          <VideoBox
            videoLink="https://www.youtube.com/watch?v=S3YYZVCUm1s"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Currency+Format+Derived+Field.jpg"
            heading="Currency Format Derived Field View Video"
          />
          <br />
          <br />
          <VideoBox
            videoLink="https://www.youtube.com/watch?v=mTkXXy2yXSs"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Setting+the+project+Timezone+to+display+Date%3ATime+in+Users+Timezone.jpg"
            heading="Setting the project Timezone to display Date/Time in Users Timezone View Video"
          />
        </ParentDocCard>
      </div>
    );
  }
}
